import { gql } from '@apollo/client';

export default gql`
  mutation deleteAnalyse($id: String!) {
    deleteAnalyse(id: $id) {
      __typename
      ... on OperationResult {
        message
      }
    }
  }
`;
